import {useBranch} from "@/hooks/useBranch";
import {getItemUrl} from "@/utils/utils";
import ArticlesWithPagination from "@/components/articlesWithPagination/ArticlesWithPagination";
import {useRouter} from "next/router";

function getCardsData(data, selectedState) {
	const facts = data?.facts || []
	const articles = data?.articles || []

	const filteredArticles = articles.filter((item) => {
		return item?.state?.handle?.toLowerCase() === selectedState
	})

	const mergedData = [...filteredArticles, ...facts].sort((a, b) =>
		new Date(b._createdAt) - new Date(a._createdAt)
	);

	const dataWithUrls = mergedData.map(item => ({
		...item,
		card: {
			...item?.card
		},
		url: getItemUrl(item)
	}))

	return dataWithUrls
}

export default function ArticlesList({data}) {
	const { locale } = useRouter()
	const {selectedOption} = useBranch();
	const cardsData = getCardsData(data, selectedOption)

	return (
		<ArticlesWithPagination
			locale={locale}
			data={cardsData}
			horizontalCards
			renderFiltration={false}
			showDate={false}
		/>
	)
}
